import React, { Component } from "react";
import styled from "styled-components";
import {
    DialogTitle,
    DialogActions,
    Button,
    TextField
} from "@material-ui/core";

import { BeautifulDialog, DialogContent, ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import { FlexBox } from "js/react/components/LayoutGrid";
import AddTagsDialog from "js/react/components/Dialogs/AddTagsDialog";
import { Field } from "js/react/components/UiComponents";
import TagsList from "js/react/components/TagsList";
import { t } from "js/i18n";

const StyledDialogTitle = styled(DialogTitle)`
    && {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
`;

const TitleText = styled.div`
    color: #333;
    font-size: 23px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: 0;
`;

const SubText = styled.div`
    color: #666;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.25;
    letter-spacing: 0;
    margin-top: 5px;
`;

const StyledDialogContent = styled(DialogContent)`
    && {
        padding: 0 50px;
        overflow-y: hidden;
    }
`;

const StyledDialogActions = styled(DialogActions)`
    &&& {
        padding-top: 18px;
        justify-content: space-between;
    }
`;

const DeleteTemplateButton = styled(Button)`
    && {
        color: #FF4500;
    }
`;

const TemplateActionGroup = styled(FlexBox)`
    gap: 12px;
`;

class CreateTeamTemplateDialogComponent extends Component {
    constructor(props) {
        super(props);
        let {
            name = "",
            description = "",
            tags = [],
        } = props;

        this.state = {
            name,
            description,
            tags,
        };
    }

    handleRemoveTag = tag => {
        const { tags } = this.state;
        let index = tags.indexOf(tag);
        if (index > -1) {
            tags.splice(index, 1);
            this.setState({
                tags,
            });
        }
    }

    handleAddTag = () => {
        const { existingTags } = this.props;
        const { tags } = this.state;

        ShowDialog(AddTagsDialog, {
            activeTags: tags,
            existingTags,
            acceptCallback: newTags => {
                this.setState({
                    tags: newTags
                });
            },
        });
    }

    handleAccept = isPublished => {
        const {
            callback,
            closeDialog,
        } = this.props;

        if (callback) {
            callback({
                ...this.state,
                isPublished,
            });
        }
        closeDialog();
    }

    handleDeleteTemplate = async () => {
        const {
            closeDialog,
            onDeleteTemplate,
        } = this.props;

        if (!onDeleteTemplate) {
            closeDialog();
            return;
        }

        closeDialog();
        await onDeleteTemplate();
    }

    render() {
        const {
            closeDialog,
            title = "[Title Missing]",
            subTitle = "[subTitle Missing]",
            onDeleteTemplate,
        } = this.props;

        const {
            name,
            description,
            tags,
        } = this.state;

        return (
            <BeautifulDialog closeDialog={closeDialog}>
                <StyledDialogTitle>
                    <TitleText>{t(title)}</TitleText>
                    <SubText>{t(subTitle)}</SubText>
                </StyledDialogTitle>

                <StyledDialogContent>
                    <Field title={t("Name")}>
                        <TextField
                            autoFocus
                            id="name"
                            value={name}
                            placeholder={t("Template name...")}
                            fullWidth
                            onChange={event => this.setState({ name: event.target.value })}
                        />
                    </Field>
                    <Field title={t("Description or instructions (optional)")}>
                        <TextField
                            multiline
                            id="description"
                            value={description}
                            placeholder={t("Give your team guidance on how and when to use this template...")}
                            fullWidth
                            onChange={event => this.setState({ description: event.target.value })}
                        />
                    </Field>
                    <Field title={t("Tags (optional)")}>
                        <TagsList
                            tags={tags}
                            onRemove={this.handleRemoveTag}
                            onClick={this.handleAddTag}
                        />
                    </Field>
                </StyledDialogContent>

                <StyledDialogActions>
                    {onDeleteTemplate ? (
                        <DeleteTemplateButton onClick={this.handleDeleteTemplate}>{t("Delete Template")}</DeleteTemplateButton>
                    ) : (
                        <Button onClick={closeDialog}>{t("Cancel")}</Button>
                    )}
                    <TemplateActionGroup>
                        <Button onClick={() => this.handleAccept(false)}>{t("Save Draft")}</Button>
                        <Button onClick={() => this.handleAccept(true)} color="primary">{t("Publish")}</Button>
                    </TemplateActionGroup>
                </StyledDialogActions>
            </BeautifulDialog>
        );
    }
}

export default CreateTeamTemplateDialogComponent;
